// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c297d40e","977":"0de0dc50"}[chunkId] + ".chunk.js";
};